import $ from "../$.js";

function findScrollRoot(obj){
  return obj.parents().filter(function(idx,node){
    //TODO there is maybe something to do with overflow(x overflow-y 
    return ['auto','scroll','overlay'].indexOf($(node).css('overflow'))!==-1;
  }).first();
  
  //maybe we do not want only the first
}

export function show(obj,zIndex){
  var 
    zRoot = obj.parent(),
    scrollRoot = findScrollRoot(obj),
    theVeil,
    data = {zIndex:obj.css('z-index'),position:obj.css('position')};
  
  zIndex = zIndex||2;
  
  if(obj.css('position')==='static'){
    obj.css('position','relative'); 
  }
  obj.css('z-index',zIndex+1);
  
  zRoot.append("<div class='fw-blackveil' style='display:block;z-index:"+zIndex+"'></div>");
  theVeil = zRoot.children().last();
  
  theVeil.get(0).addEventListener('mousewheel',function(origEvt){
    var rootDom = scrollRoot.get(0);
    if(rootDom){
      rootDom.scrollBy(-origEvt.wheelDeltaX,-origEvt.wheelDeltaY)
    }
  },{passive:true});
  
  theVeil.attr('data-veil',JSON.stringify(data))
  theVeil.on('click',ev=>ev.stopPropagation())
  return theVeil;
}
export function hide(obj){
  if(!obj) return;
  var 
    zRoot = obj.parent(),
    theVeil = zRoot.find('.fw-blackveil').last();
  
  if(theVeil.attr('data-veil')){
    var data = JSON.parse(theVeil.attr('data-veil'));
    obj.css('z-index',data.zIndex)
    setTimeout(function(){obj.css('position',data.position)},500) //at the end of the animation
  }else{
    //FIXME it happen
    // when we quit the home with the activity form
  }
  theVeil.remove()
  return theVeil;
}